import styled from '@mui/material/styles/styled';
import Typography from '@mui/material/Typography';

// Uploader
export const UploaderTitle = styled((props) => (
  <Typography {...props} />
))({
  width: 'min(100%, 560px)',
  fontSize: '2rem',
  fontWeight: 700,
  textAlign: 'center',
});